export const DRAWING_MODES = ['pen', 'eraser'] as const;
export const MODES = [...DRAWING_MODES, 'select', 'text', 'color', 'shape'] as const;
export const DEFAULT_BRUSH_WIDTH = 10;
export const IMAGE_MODEL_ID_KEY = 'imageModelId';

export type DrawingMode = typeof DRAWING_MODES[number];
export type Mode = typeof MODES[number];
